var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 1.66699H12.5002C11.3951 1.66699 10.3353 2.10598 9.55388 2.88738C8.77248 3.66878 8.3335 4.72859 8.3335 5.83366V8.33366H5.8335V11.667H8.3335V18.3337H11.6668V11.667H14.1668L15.0002 8.33366H11.6668V5.83366C11.6668 5.61265 11.7546 5.40068 11.9109 5.2444C12.0672 5.08812 12.2791 5.00033 12.5002 5.00033H15.0002V1.66699Z",
    stroke: "#1A4D3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.60bce388a9af5db4b767772b083f571f.svg";
export { ForwardRef as ReactComponent };